import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

declare function gtag(...args: unknown[]): void;

@Injectable({
    providedIn: 'root',
})
export class GoogleAnalyticsService {
    private initialized = false;

    constructor(private router: Router) {}

    private titleFromPath(path: string): string {
        const clean = path
            .split('?')[0]
            .split('#')[0]
            .replace(/^\/+|\/+$/g, '');
        if (!clean) return 'Home';
        return clean
            .split('/')
            .map(seg => seg.replace(/[-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase()))
            .join(' - ');
    }

    init(): void {
        if (this.initialized) return;
        if (!environment.production || !environment.gaMeasurementId) return;
        this.initialized = true;

        const id = environment.gaMeasurementId;
        this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe(event => {
            if (typeof gtag === 'function') {
                const path = event.urlAfterRedirects;
                const title = this.titleFromPath(path);
                gtag('config', id, { page_path: path, page_title: title });
            }
        });
    }
}
